import request from '@/utils/request'

let DrivertabApi = {

  /*招聘Tab列表*/
  list(data) {
    return request._post('/shop/plus.drivertab.Index/index', data);
},
/*添加招聘Tab*/
add(data) {
    return request._post('/shop/plus.drivertab.Index/add', data);
},
/*修改招聘Tab*/
edit(data) {
    return request._post('/shop/plus.drivertab.Index/edit', data);
},
/*删除招聘Tab*/
del(data) {
    return request._post('/shop/plus.drivertab.Index/del', data);
},
/*招聘Tab详情*/
detail(data) {
  return request._post('/shop/plus.drivertab.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.drivertab.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.drivertab.Setting/getSetting', data, errorback);
    },
}
export default DrivertabApi;



// WEBPACK FOOTER //
// ./src/api/drivertab.js